import React, { useEffect, useState, useRef } from 'react'

// Deps
import { setError } from 'controllers/navigator'
import { redirect } from 'controllers/navigator';

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import Breadcrumbs from 'views/admin/sections/breadcrumbs'
import Tabs from 'views/shared/partials/tabs'
import Btn from 'views/shared/partials/btn'
import Pricebox from 'views/shared/partials/pricebox'

// Functions
import getCurrency from 'functions/get-currency'
import formatDate from 'functions/format-date'

// Utils
import { openModal } from 'utils/modals';

// Services
import companyServices from 'services/company'

const checkPaymentFeedback = (search) => {

	let rawParams = search ? search.split('?')[1] : false;
	let params = false;

	if(rawParams) {
		params = {};
		rawParams = rawParams.split('&');

		for(const paramString of rawParams) {
			let dPar = paramString.split('=');
			params[dPar[0]] = dPar[1];
		}
		
		setTimeout(() => {
			redirect({ type: 'replace', to: 'settings.balanceReports' });
		}, 250)
	}

	return params;
}

const BalanceReports = (props) => {
	const paymentFeedback = checkPaymentFeedback(props.location.search);
	
	const dataCount = useRef(0);
	const feedbackStatus = useRef(paymentFeedback ? paymentFeedback.status : false);
	const feedbackMessage = useRef(paymentFeedback ? paymentFeedback.message : false);
	const previousCurrency = useRef(paymentFeedback ? getCurrency(paymentFeedback.price_id, 'id') : false);

	const [balanceCache, setBalanceCache] = useState(false);
	const [balanceGroups, setBalanceGroups] = useState(false);
	const [activeReportGroup, setActiveReportGroup] = useState(false);
	
	useEffect(() => {
		companyServices.listBalanceStatusReports().then((payload) => {
			setBalanceCache(payload);
		}).catch(() => {
			setError();
		})
	}, [])
	
	useEffect(() => {
		if(balanceCache && balanceCache.length && !balanceCache[0].reports){
			dataCount.current = 0;

			for(let k = 0; k < balanceCache.length; k++) {
				dataCount.current++;

				companyServices.listBalanceReports(getCurrency(balanceCache[k].currency_code).id).then((reportData) => {
					let newGroups = [...balanceCache];
					newGroups[k].reports = reportData;
					newGroups[k].increase = parseInt(newGroups[k].credit) > 0;
					setBalanceCache(newGroups);

					dataCount.current--;

					if(dataCount.current === 0) {
						setBalanceGroups(balanceCache);
						setActiveReportGroup(previousCurrency.current ? balanceCache.find((curr) => (curr.currency_code === previousCurrency.current.code)) : 
							balanceCache[0]);
					}
				}).catch(() => {
					setError();
				})
			}
		}
	}, [balanceCache])

	return (
		<main className="page balance-reports">
			<Breadcrumbs />

			{feedbackStatus.current === 'success' &&
				<div className="page-message alert success">
					<i className="alert-icon icon-check big"></i>
					<div className="alert-message">
						<strong>Bakiye yükleme başarılı</strong>
						<p>Bakiyeniz hesabınıza aktarıldı.</p>
					</div>
				</div>
			}
			{feedbackStatus.current === 'fail' &&
				<div className="page-message alert error">
					<i className="alert-icon icon-alert-2 big"></i>
					<div className="alert-message">
						<strong>Bakiye yükleme hatası</strong>
						<p>{feedbackMessage.current ? feedbackMessage.current : 'Bakiye yüklenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'}</p>
					</div>
				</div>
			}
			<section className="portlet section reports-container loader-container">
				<div className="portlet-header">
					<h1 className="portlet-title">Bakiye Özeti</h1>

					<div className="header-controls">
						<Btn
							white small wide icon="payment"
							disabled={!activeReportGroup}
							onClick={() => {
								openModal('load-balance', { currencyType: activeReportGroup, currencies: balanceGroups });
							}}>
							Bakiye Yükle
						</Btn>
					</div>
				</div>
				{(balanceGroups === false || balanceGroups.length > 0) &&
					<Tabs
						onChange={(groupNth) => {
							setActiveReportGroup(balanceGroups[groupNth]);
						}}>
						{balanceGroups &&
							<React.Fragment>
								{balanceGroups.map((group, nth) => (
									<div
										active={activeReportGroup ? activeReportGroup.currency_code === group.currency_code : undefined}
										key={group.currency_code}
										index={nth}
										badge={group.credit + ' ' + group.currency_symbol}
										badgeClass={group.increase ? 'success' : 'error'}
										label={group.currency_code}>
										<div className="low">
											<Table
												emptyMessage="Bakiye bilgisi bulunamadı."
												onPaginate={(page) => { props.onPaginate(page); }}
												heading={
													<React.Fragment>
														<th>Tarih</th>
														<th>Açıklama</th>
														<th>Kredi</th>
														<th>İşlem Sayısı</th>
													</React.Fragment>
												}>

												{group.reports.map((report, nth) => (
													<TR key={nth} mobileTitle={ formatDate(report.start_date, 'dd MMMM yyyy')}>
														<TD>
															<p className="hide-mobile">
																{formatDate(report.start_date, 'dd MMMM yyyy')}
															</p>
															<p className="table-subtitle">
																{formatDate(report.start_date, 'HH:mm')}
															</p>
														</TD>
														<TD mobileTitle="açıklama" className="mobile-full">
															{report.relation_name}
														</TD>
														<TD mobileTitle="Kredi">
															<Pricebox
																code={report.currency_code}
																price={report.credits} />
														</TD>
														<TD mobileTitle="İşlem Sayısı">
															{report.relation_count}
														</TD>
													</TR>
												))}
											</Table>
										</div>
									</div>
								))}
							</React.Fragment>
						}
					</Tabs>
				}
				{(balanceGroups && balanceGroups.length === 0) &&
					<div className="portlet-section bottom">
						<div className="alert warning center block">
							<div className="alert-content">
								Listelenecek rapor bulunamadı.
							</div>
						</div>
					</div>
				}
			</section>
		</main>
	)
}

export default BalanceReports